import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { EventWaitlistEntryDto } from '../../../models/event/dto/event-waitlist-entry.dto';

export const GET_EVENT_WAITLIST_QUERY_KEY = (eventId: number) => [
    'event-waitlist',
    eventId,
];

/**
 * Admin view of an event's waitlist (MYS-62). Includes level-gated approval
 * requests (reason='level') alongside classic capacity-overflow entries.
 */
export const useGetEventWaitlist = (eventId: number) => {
    const apiClient = useApiClient();

    return useQuery<EventWaitlistEntryDto[]>({
        queryKey: GET_EVENT_WAITLIST_QUERY_KEY(eventId),
        queryFn: async () =>
            apiClient.fetchApi<EventWaitlistEntryDto[], {}>({
                method: 'GET',
                endpoint: `events/${eventId}/waitlist`,
            }),
        enabled: !!eventId,
    });
};
